import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Paper, Grid, Typography } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import useStyles from "../../styles/deviceStyle";
import { useTranslation } from "../../langs/useTranslation";
// import { useParams } from "react-router-dom";
import DeviceOwners from "../commons/DeviceOwners";
import useStateOnMounted from "../../helpers/useStateOnMounted";
import { scheduledDateInLocal } from "../../helpers/datetimeHandlers";
import HasPermission from "../commons/HasPermission";
import ChangeDeviceTagModal from "@/containers/GroupsDevices/TransferGroupTagModal";
import { deviceModifyAPI } from "@/apis/deviceModifyAPI";
import { tagBindDeviceAPI } from "@/apis/tagBindDeviceAPI";
import { toast } from "@/apis/request";
import SearchInput from "../SearchInput";
import {
  updateDeviceDetailApi,
  updateDeviceNameApi
} from "@/apis/apiCollection";
import { TaskStatus } from "../commons/TaskStatusBar";
import ChipStatus from "../ChipStatus";
import { getTwinsDesiredOrReportedByLastUpdated } from "@/helpers/utils";
import { APP_ENV } from "@/APP_ENV";

const DeviceDetailBasicData = props => {
  // const { device_id } = useParams();
  const {
    loading,
    deviceId,
    deviceData = {},
    reportedTwins,
    twinsData,
    setDeviceData,
    osType,
    system,
    hardware,
    openMore,
    onlineStatus
  } = props;
  const { t, langConf } = useTranslation("device");
  const { t: t2 } = useTranslation("deviceControl");
  const classes = useStyles();
  const [editDetail, setEditDetail] = useStateOnMounted(false);
  const [editDeviceName, setEditDeviceName] = useStateOnMounted(false);
  const [changeDeviceTagModalOpen, setChangeDeviceTagModalOpen] =
    useStateOnMounted(false);
  const history = useHistory();
  const oraDebug = APP_ENV.REACT_APP_ORA_DEBUG;

  const net =
    deviceData &&
    deviceData.networks &&
    deviceData.networks[0] &&
    deviceData.networks[0].json &&
    deviceData.networks[0].json[0];

  const companies = useMemo(() => {
    return deviceData.companies?.map(companyObj => companyObj.name) ?? "";
  }, [deviceData.companies]);

  const screenRotation = useMemo(() => {
    return twinsData
      ? getTwinsDesiredOrReportedByLastUpdated(twinsData, "screen_rotation")
      : undefined;
  }, [twinsData]);

  const handleChangeDeviceTagConfirm = async (checkedKeys, checkedItems) => {
    let res = await deviceModifyAPI(
      "tag",
      checkedKeys.length && checkedKeys,
      !checkedKeys.length && deviceData.tags?.map(tag => tag.id)
    );
    if (res) {
      res = await tagBindDeviceAPI(checkedKeys, deviceId);
      if (res?.message === "success") {
        setDeviceData({ ...deviceData, tags: checkedItems });
        toast.success(t({ defaultMessage: "操作成功" }));
      }
      setChangeDeviceTagModalOpen(false);
    }
  };

  const handleEndEditDetail = async e => {
    const { value } = e.target;
    if (value !== deviceData.detail) {
      await updateDeviceDetailApi({
        deviceId,
        detail: value
      });
    }
    setEditDetail(false);
    setDeviceData({ ...deviceData, detail: value });
  };

  const handleEndEditDeviceName = async e => {
    const { value } = e.target;
    if (value !== deviceData.deviceName) {
      await updateDeviceNameApi({
        device_id: deviceId,
        device_name: value
      });
    }
    setEditDeviceName(false);
    setDeviceData({ ...deviceData, device_name: value });
  };

  useEffect(() => {
    if (deviceData.kiosk_mode) {
      sessionStorage.setItem(
        "kiosk_mode_" + deviceData.id,
        deviceData.kiosk_mode
      );
    }
  }, [deviceData.kiosk_mode]);

  return (
    <div>
      <Paper elevation={0} style={{ padding: "20px 30px" }}>
        <div className={classes.deviceDetail_title}>
          <Typography variant="h5">{t("category.information")}</Typography>
          <Typography
            variant="body2"
            color="secondary"
            className={classes.more}
            onClick={openMore}
          >
            More
          </Typography>
        </div>
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="center"
          className={classes.deviceDetail_BasicData}
        >
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.deviceId")}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {deviceData.device_key ? deviceData.device_key : "-"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.deviceSN")}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {deviceData.serial_number ? deviceData.serial_number : "-"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.osType")}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {osType ? osType : "-"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.belongTo")}
              </Typography>
              <div className={classes.deviceDetail_value}>
                {companies ? <DeviceOwners owners={companies} /> : "-"}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.location")}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {system && system.json ? system?.json.location : "-"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t({ defaultMessage: "时区" })}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {system && system.json ? system?.json.timezone : "-"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.status")}
              </Typography>
              <div className={classes.deviceDetail_value}>
                {onlineStatus ? (
                  <div className={classes[onlineStatus]}>
                    {onlineStatus[0].toUpperCase() + onlineStatus.slice(1)}
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.oraVersion", { ora: langConf.deviceCenter?.oraText || "Ora" })}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {deviceData.ora_version ? deviceData.ora_version : "-"}
              </Typography>
            </div>
          </Grid>
          {/* <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <div className={classes.deviceDetail_text}>
                {t("category.nubisVersion", {nubis: langConf.deviceCenter?.nubisText || "Nubis"})}
              </div>
              <div className={classes.deviceDetail_value}>
                {deviceData.nubis_version
                  ? deviceData.nubis_version === "nubis_pro"
                    ? "Nubis Pro"
                    : "Nubis Free"
                  : "-"}
              </div>
            </div>
          </Grid> */}
          {APP_ENV.REACT_APP_CMS_ENABLED && (
            <>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <div className={classes.deviceDetail_DateSet}>
                  <div className={classes.deviceDetail_text}>
                    {t({ defaultMessage: "{nubis} Cast版本" }, { nubis: langConf.deviceCenter?.nubisText || "Nubis" })}
                  </div>
                  <div className={classes.deviceDetail_value}>
                    {deviceData.cast_version || "-"}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <div className={classes.deviceDetail_DateSet}>
                  <div className={classes.deviceDetail_text}>
                    {t({ defaultMessage: "{nubis} Cast模式" }, { nubis: langConf.deviceCenter?.nubisText || "Nubis" })}
                  </div>
                  <div className={classes.deviceDetail_value}>
                    <ChipStatus
                      type="info"
                      label={
                        deviceData.additional_type === 1 ? t({ defaultMessage: "开启" }) : t({ defaultMessage: "关闭" })
                      }
                    />
                  </div>
                </div>
              </Grid>
            </>
          )}
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <div className={classes.deviceDetail_text}>
                {t({ defaultMessage: "Kiosk模式" })}
              </div>
              <div className={classes.deviceDetail_value}>
                <ChipStatus
                  type="info"
                  label={
                    reportedTwins?.kiosk_mode === undefined
                      ? t({ defaultMessage: "未知" })
                      : reportedTwins?.kiosk_mode === 1
                        ? t({ defaultMessage: "开启" })
                        : t({ defaultMessage: "关闭" })
                  }
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <div className={classes.deviceDetail_text}>
                {t2("common.rotation")}
              </div>
              <div className={classes.deviceDetail_value}>
                {twinsData && (
                  <ChipStatus
                    type="info"
                    label={
                      (screenRotation === undefined &&
                        t({ defaultMessage: "未知" })) ||
                      (screenRotation === "landscape" &&
                        t2("common.rotationOriginal")) ||
                      (screenRotation === "upside_down" &&
                        t2("common.rotationUpsideDown")) ||
                      (screenRotation === "right" &&
                        t2("common.rotationRightText")) ||
                      (screenRotation === "left" && t2("common.rotationLeft"))
                    }
                  />
                )}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.activatedDate")}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {deviceData.created_at
                  ? scheduledDateInLocal(deviceData.created_at)
                  : "-"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.lastestOnline")}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {deviceData.heart_beated_at
                  ? scheduledDateInLocal(deviceData.heart_beated_at)
                  : "-"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t({ defaultMessage: "{ora}最后更新时间" }, { ora: langConf.deviceCenter?.oraText || "Ora" })}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {deviceData.last_updated_at
                  ? scheduledDateInLocal(deviceData.last_updated_at)
                  : "-"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t({ defaultMessage: "{ora}最后更新状态" }, { ora: langConf.deviceCenter?.oraText || "Ora" })}
              </Typography>
              <Typography
                variant="body2"
                component="div"
                className={classes.deviceDetail_value}
              >
                {deviceData.last_updated_status ? (
                  <TaskStatus status={deviceData.last_updated_status} />
                ) : (
                  "-"
                )}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t({ defaultMessage: "image最后更新时间" })}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {deviceData.image_last_updated_at
                  ? scheduledDateInLocal(deviceData.image_last_updated_at)
                  : "-"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t({ defaultMessage: "image最后更新状态" })}
              </Typography>
              <Typography
                variant="body2"
                component="div"
                className={classes.deviceDetail_value}
              >
                {deviceData.image_last_updated_status ? (
                  <TaskStatus status={deviceData.image_last_updated_status} />
                ) : (
                  "-"
                )}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.MAC")}
              </Typography>
              <Typography
                variant="body2"
                className={classes.deviceDetail_value}
              >
                {hardware && hardware.motherboard?.json.mac_address
                  ? hardware.motherboard.json.mac_address
                  : net && net.mac_address
                    ? net.mac_address
                    : "-"}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.groups")}
              </Typography>
              <div className={classes.deviceDetail_value}>
                {deviceData.groups
                  ? deviceData.groups.map(group => group.name).join(", ")
                  : "-"}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <div className={classes.deviceDetail_DateSet}>
              <Typography variant="body2" className={classes.deviceDetail_text}>
                {t("category.tags")}
              </Typography>
              <div className={classes.deviceDetail_value}>
                <span>
                  {deviceData.tags
                    ? deviceData.tags.map(tag => tag.name).join(", ")
                    : "-"}
                </span>
                {!loading && (
                  <HasPermission permission="device_tag_mapping_maintain_tag">
                    <Edit
                      onClick={() => setChangeDeviceTagModalOpen(true)}
                      fontSize="small"
                      style={{ marginLeft: 10, cursor: "pointer" }}
                    />
                  </HasPermission>
                )}
              </div>
            </div>
          </Grid>
          <HasPermission permission="">
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className={classes.deviceDetail_DateSet}>
                <Typography
                  variant="body2"
                  className={classes.deviceDetail_text}
                >
                  {t({ defaultMessage: "设备名称" })}
                </Typography>
                <div className={classes.deviceDetail_value}>
                  {editDeviceName ? (
                    <SearchInput
                      icon={null}
                      autoFocus
                      defaultValue={deviceData.device_name}
                      onPressEnter={handleEndEditDeviceName}
                      onBlur={handleEndEditDeviceName}
                    />
                  ) : (
                    <>
                      <span style={{ wordBreak: "break-all" }}>
                        {deviceData.device_name}
                      </span>
                      {!loading && (
                        <Edit
                          style={{ marginLeft: 10, cursor: "pointer" }}
                          fontSize="small"
                          onClick={() => setEditDeviceName(true)}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            </Grid>
          </HasPermission>
          <HasPermission permission="device_control_device_description">
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className={classes.deviceDetail_DateSet}>
                <Typography
                  variant="body2"
                  className={classes.deviceDetail_text}
                >
                  {t({ defaultMessage: "描述" })}
                </Typography>
                <div className={classes.deviceDetail_value}>
                  {editDetail ? (
                    <SearchInput
                      icon={null}
                      autoFocus
                      defaultValue={deviceData.detail}
                      onPressEnter={handleEndEditDetail}
                      onBlur={handleEndEditDetail}
                    />
                  ) : (
                    <>
                      <span>{deviceData.detail}</span>
                      {!loading && (
                        <Edit
                          style={{ marginLeft: 10, cursor: "pointer" }}
                          fontSize="small"
                          onClick={() => setEditDetail(true)}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            </Grid>
          </HasPermission>
          {deviceData.config_history_id && (
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className={classes.deviceDetail_DateSet}>
                <Typography
                  variant="body2"
                  className={classes.deviceDetail_text}
                >
                  {t({ defaultMessage: "配置文件" })}
                </Typography>
                <div
                  className={classes.configFile}
                  onClick={() => {
                    if (deviceData.os_type === "windows")
                      history.push(
                        `/profile-config/install-history-windows/${deviceData.config_history_id}`
                      );
                    else
                      history.push(
                        `/profile-config/install-history/${deviceData.config_history_id}`
                      );
                  }}
                >
                  {deviceData.config_name}
                </div>
              </div>
            </Grid>
          )}
          {oraDebug && (
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className={classes.deviceDetail_DateSet}>
                <Typography
                  variant="body2"
                  className={classes.deviceDetail_text}
                >
                  {t({ defaultMessage: "debugInfo" })}
                </Typography>
                <div className={classes.deviceDetail_value}>
                  {deviceData.ora_debug_info}
                </div>
              </div>
            </Grid>
          )}
        </Grid>
      </Paper>
      <ChangeDeviceTagModal
        value={deviceData.tags?.map(tag => tag.id)}
        open={changeDeviceTagModalOpen}
        onClose={() => setChangeDeviceTagModalOpen(false)}
        onConfirm={handleChangeDeviceTagConfirm}
      />
    </div>
  );
};

export default React.memo(DeviceDetailBasicData);
